import { UAParser } from 'ua-parser-js';
const { REACT_APP_VERSION } = process.env;

const parser = new UAParser();
const meta = {
  appType: 'web',
  appVersion: REACT_APP_VERSION,

  deviceOS: parser.getOS().name,
  deviceVersion: parser.getOS().version,
  browserType: parser.getBrowser().name,
  browserVersion: parser.getBrowser().version
}

export function getMeta(){
  return meta;
}